import { useResetRecoilState } from 'recoil';
import { useQueryClient } from '@tanstack/react-query';

import { currentPractice } from 'components/practice/practiceState';
import { modulesState, permissions, settings } from 'components/state';

/**
 * Drops the practice- and user-scoped client state on logout. Every logout path navigates by SPA,
 * so without this the next user to sign in on the same tab inherits the previous session's
 * Recoil atoms and React Query cache. Session-persisted atoms are reset by
 * `useResetSessionOnAccountChange` and their storage swept by `clearScopedSessionStorage`.
 *
 * @returns {() => void} Resets the session-scoped atoms and clears the query cache
 */
const useResetSessionState = () => {
  const queryClient = useQueryClient();
  const resetPractice = useResetRecoilState(currentPractice);
  const resetPermissions = useResetRecoilState(permissions);
  const resetModules = useResetRecoilState(modulesState);
  const resetSettings = useResetRecoilState(settings);

  return () => {
    resetPractice();
    resetPermissions();
    resetModules();
    resetSettings();
    queryClient.clear();
  };
};

export default useResetSessionState;
